const convertLineBreaks = (str = "") => {
  let value = String(str)
  value = value.replace(/(?:\r\n|\r|\n)/g, "<br>")
  return value
}

export default convertLineBreaks
